///
/// EarthBrowser
///
/// Created by Matt Giger on 2/3/2025
/// Copyright (c) 2025 Geodata Labs
///

import { ShaderProgram } from "@stovokor/shader/ShaderProgram"
import { combineDefines, ShaderSourceDefinition } from "@stovokor/shader/ShaderSourceCode"
import { type StovokorContext } from "@stovokor/StovokorContext"
import { type GLTFGeometry } from "./GLTFGeometry"
import { type GLTFMaterial } from "./GLTFMaterial"

export class GLTFShaderProgram extends ShaderProgram {

	constructor(context: StovokorContext, geometry: GLTFGeometry, material: GLTFMaterial) {
		const defines = combineDefines([geometry.requiredAttributes(), material.requiredAttributes()])
		const source = new ShaderSourceDefinition("gltf", defines)
		super(context, source)
	}
}